/**
 * React admin has following url structure
 * https://<domain>/#/<route>?<urlparams>
 * this function parses this string
 * @returns `new URLSearchParams` object
 */
export const getRAUrlParams = (url = window.location.href) => {
  const indexOfParamStart = url.indexOf("?");
  const indexOfParamStartExists = indexOfParamStart >= 0;
  let search = "";
  if (indexOfParamStartExists) {
    search = url.slice(indexOfParamStart);
  }
  return new URLSearchParams(search);
};

/**
 * React admin has following url structure
 * https://<domain>/#/<route>?<urlparams>
 * this function parses this string
 * @returns pathname
 */
export const getRAUrlPathName = (url = window.location.href) => {
  const indexOfPathname = url.indexOf("/#/");
  const indexOfPathnameExists = indexOfPathname >= 0;
  const indexOfParamStart = url.indexOf("?");
  const indexOfParamStartExists = indexOfParamStart >= 0;
  let pathname = url;
  if (indexOfParamStartExists) {
    pathname = pathname.slice(0, indexOfParamStart);
  }
  if (indexOfPathnameExists) {
    pathname = pathname.slice(indexOfPathname).replace("/#/", "");
  }
  return pathname;
};

export const updateUrlWithParam = ({ path, key, value }) => {
  if (!key || !value) return path; // Ensure key and value are valid

  return `${path}${path.includes("?") ? "&" : "?"}${key}=${value}`;
};
